export const BYTES_IN_MB = 1048576;
export const BYTES_IN_GB = 1073741824;

export const bytesToMB = (bytes: number): number => bytes / BYTES_IN_MB;
export const bytesToGB = (bytes: number): number => bytes / BYTES_IN_GB;

export const getSizeMB = (fileSize: number): number => bytesToMB(fileSize);
